module.exports = __webpack_public_path__ + "img/active_7.954e84ef.png";